<template>
    <div class="termination-box">
        <p class="alert-contract-terminated text-center">
            <strong v-if="schedule.case_is_explained_date !== null">
                Umowa w egzekucji. Data rozpoczęcia egzekucji
                {{ schedule.case_is_explained_date }}<br />
            </strong>

            <d-button
                class="m-top mb-1"
                theme="danger"
                @click.prevent="cancelExplained(schedule.id)"
            >
                Cofnij egzekucję
            </d-button>
        </p>
    </div>
</template>

<script>
import LarErrors from '@/helpers/Errors';
import Vue from 'vue';

export default {
  name: 'ContractBasicInfoExplainedBox',
  props: {
    schedule: {
      required: true,
      type: Object,
    },
  },
  methods: {
    cancelExplained(id) {
      Vue.swal({
        title: 'Uwaga',
        html: 'Czy potwierdzasz, że chcesz wycofać egzekucję?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Tak',
        cancelButtonText: 'Nie',
        buttonsStyling: true,
      }).then((submit) => {
        if (submit.value) {
          axios
            .post('api/schedules/reset-schedule-as-cased', {
              id,
            })
            .then((_) => {
              Vue.swal({
                type: 'success',
                title: 'Egzekucja została wycofana',
                showConfirmButton: true,
              }).then(() => {
                this.$bus.$emit('reload-contract');
              });
            })
            .catch((error) => {
              LarErrors.record(error.response.data.errors);

              Vue.swal({
                type: 'warning',
                title: 'Wystąpił błąd',
                text: error.response.data.error
                  ? error.response.data.error
                  : 'Spróbuj ponownie później',
                showConfirmButton: true,
              });
            });
        }
      });
    },
  },
};
</script>
